<template>
  <transition name="slide">
  <ul class="colorset-list-view" @click="$emit('click')">
    <li class="col" v-for="(item, index) in colorset.array" :key="index">
      <span class="color-label" :style="{
        backgroundColor:itemCssColor(item),
      }"></span>
      <span class="color-code">{{colorCode(item)}}</span>
      <span class="copy" @click.stop="copyItemColor(item)">COPY</span>
    </li>
  </ul>
  </transition>
</template>

<style scoped>
  ul {
    margin: 0;
    padding: 5px 15px;
    list-style: none;
    width: 100%;
    background: white;
    text-align: left;
    box-shadow: 0px 0px 33px 0px #333;
  }
  li {
    margin: 0;
    padding: 5px 0;
  }
  .col {
    display: inline-block;
    width: 49%;
    text-align: center;
  }
  .color-label {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-right: 5px;
    border-radius: 4px;
    position: relative;
    top: 5px;
  }
  .color-code {
    font-size: 10pt;
    color: #333;
    font-family: "Courier New", Consolas, monospace;
    font-weight: bold;
  }
  .copy {
    font-size: 8pt;
    border: 1px solid #aaa;
    border-radius: 8px;
    padding: 2px 4px;
  }
  /* animation */
  .slide-enter-active, .slide-leave-active {
    transition: all 300ms 0s cubic-bezier(.41,.8,.67,1);
  }
  .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    bottom: -150px
  }

</style>

<script>
import Colorset from '@/models/Colorset'
import * as atypes from '@/store/action-types'
export default {
  name: 'ColorsetListView',
  props: {
    colorset: Colorset
  },
  computed: {
  },
  methods: {
    itemCssColor (colorItem) {
      const rgb = colorItem.c
      return '#' + rgb.map(v => Math.floor(v).toString(16).padStart(2, '0')).join('')
    },
    colorCode (colorItem) {
      return this.itemCssColor(colorItem)
    },
    copyItemColor (colorItem) {
      const selection = window.getSelection()
      const range = document.createRange()
      const pre = document.createElement('pre')
      pre.style.position = 'absolute'
      pre.style.fontSize = '0'
      document.body.appendChild(pre)
      pre.textContent = this.itemCssColor(colorItem)
      range.selectNodeContents(pre)
      selection.removeAllRanges()
      selection.addRange(range)
      const ret = document.execCommand('copy')
      if (ret) {
        this.$store.dispatch(atypes.FLASH_SET_MSG, {msg: 'Copied'})
      } else {
        this.$store.dispatch(atypes.FLASH_SET_MSG, {msg: 'ERROR'})
      }
      selection.removeAllRanges()
      pre.parentNode.removeChild(pre)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorsetListView.vue